import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@infrastructure/firebase/analytics';
import { findDestination } from '../shell/navigation';

/**
 * Una vista por pantalla, no una por sesión.
 *
 * `getAnalytics` dispara la vista de la primera carga y nada más: en una SPA la
 * navegación no recarga el documento, así que sin esto la propiedad de GA4
 * mediría **una sola pantalla por persona** —aquella por la que entró— y la
 * lectura sería que nadie usa el portal más allá de Inicio.
 *
 * Va en el shell y no en cada pantalla por lo mismo que la navegación es una
 * tabla: veinte pantallas llamando a lo mismo son veinte sitios donde falta uno.
 *
 * **El nombre sale de la tabla de navegación**, no de `document.title`, que en
 * este portal es «Vacaciones» en todas partes. Sin eso, el informe sería una
 * lista de rutas y alguien tendría que traducirlas a mano.
 */
export const usePageViews = (): void => {
  const location = useLocation();

  useEffect(() => {
    const destino = findDestination(location.pathname);
    trackPageView(location.pathname, destino?.label ?? location.pathname);
  }, [location.pathname]);
};
